<div class="main-div">
  <app-loading-spinner></app-loading-spinner>
</div>
